import axios from "axios";
let axiosUpload = axios.create({
	baseURL: "/api/v1/ohst",
	timeout: 30000
});
axiosUpload.defaults.headers.put["Content-Type"] = "application/x-www-form-urlencoded";
axiosUpload.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
class ohst_api {
	constructor(axiosFactory) {
		this.$http = axiosFactory;
	}
	http() {
		return this.$http;
	};
	get(url, cb) {
		this.$http.get(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});;
	}
	gets(url, data, cb) {
		this.$http.get(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	post(url, data, cb) {
		this.$http.post(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	posts(url, cb) {
		this.$http.post(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	put(url, data, cb) {
		this.$http.put(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	puts(url, cb) {
		this.$http.put(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	delete(url, data, cb) {
		this.$http.delete(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	deletes(url, cb) {
		this.$http.delete(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	//------------------------------------------------------------
	//猎头统计数据====
  getHunterStatisData(hunterName, cb) {
  	this.get(`/hunter/server/for?userName=${hunterName}`, cb)
  }

}
class apiFactory {
	constructor() {

	}
	createApi(axios) {
		return new ohst_api(axios)
	}
}
export default new apiFactory();
